import { stringify as queryStringify } from "querystring"

type EmailUnsubscribeUrlOptions = {
  appKey: string
  channelId: string
  redirectUrl?: string
}

type EmailUnsubscribeQueryParams = {
  app_key: string
  channel_id: string
  message_type: "commercial" | "transactional"
  redirect?: string
}

const EMAIL_UNSUBSCRIBE_URL_PATH = "/api/channels/email/unsubscribe"

export function createEmailUnsubscribeUrl({
  appKey,
  channelId,
  redirectUrl,
}: EmailUnsubscribeUrlOptions): string {
  const params: EmailUnsubscribeQueryParams = {
    app_key: appKey,
    channel_id: channelId,
    message_type: "commercial",
  }

  if (redirectUrl) {
    params.redirect = redirectUrl
  }

  return `${EMAIL_UNSUBSCRIBE_URL_PATH}?${queryStringify(params)}`
}
